import type { Feature } from '../../content/types';
import { InlineCode } from '../InlineCode';

type FeatureCardProps = {
  feature: Feature;
  roadmapBadgeLabel: string;
};

export function FeatureCard({ feature, roadmapBadgeLabel }: FeatureCardProps) {
  const isRoadmap = feature.roadmap === true;

  return (
    <article className={'flex flex-col gap-4 py-8 md:py-10' + (isRoadmap ? ' opacity-70' : '')}>
      <header className="flex flex-wrap items-baseline gap-x-4 gap-y-2">
        <h4 className="font-display text-3xl leading-tight font-medium text-[color:var(--color-foreground)] md:text-4xl">
          {feature.name}
        </h4>
        {isRoadmap && (
          <span className="inline-block border border-[color:var(--color-ghost-border)] px-2 py-1 font-sans text-xs tracking-[var(--tracking-button)] text-[color:var(--color-foreground)]/80 uppercase">
            {roadmapBadgeLabel}
          </span>
        )}
      </header>

      <p className="font-body text-base leading-relaxed text-[color:var(--color-foreground)]/80 md:text-lg">
        <InlineCode>{feature.description}</InlineCode>
      </p>

      {feature.bullets.length > 0 && (
        <ul className="flex flex-col gap-2 font-[family-name:var(--font-ui)] text-sm leading-relaxed text-[color:var(--color-foreground)]/70 md:text-base">
          {feature.bullets.map((bullet, index) => (
            <li key={index} className="flex gap-3">
              <span aria-hidden="true" className="shrink-0 text-[color:var(--color-ghost-border)]">
                •
              </span>
              <span>
                <InlineCode>{bullet}</InlineCode>
              </span>
            </li>
          ))}
        </ul>
      )}
    </article>
  );
}
